import React from 'react';

class ViewMore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false,
            idUnique: `text_${Date.now()}_${Math.floor(Math.random()*1000000000)}`,
            height: 0,
            limit: 100000
        };

        this.heightOfChildren = this.heightOfChildren.bind(this);
    }

    componentDidMount(){
        this.setHeightOfChild();
    }

    componentWillUnmount(){
        this.clearTimer();
    }

    setHeightOfChild = () => {
        if (this.timerHandle) {
            // Exception?
            return;
        }
        // Remember the timer handle
        this.timerHandle = setTimeout(() => {
            this.heightOfChildren();
            this.timerHandle = 0;
        }, 100);
    };

    clearTimer = () => {
        // Is our timer running?
        if (this.timerHandle) {
            // Yes, clear it
            clearTimeout(this.timerHandle);
            this.timerHandle = 0;
        }
    };

    
    heightOfChildren(){
        let cleanHtmlHeight = document.getElementById(this.state.idUnique) && document.getElementById(this.state.idUnique).clientHeight;
        this.setState({height: cleanHtmlHeight || 10, limit: this.props.limit || 10});
        if(cleanHtmlHeight === 0){
            setTimeout(() => {
                this.heightOfChildren();
                this.timerHandle = 0;
            }, 300);
        }
    }

    render() {

        return (
            <div className={`column view-more-block ${(this.state.height > this.state.limit) && !this.state.showMore ? 'hide-text' : ''}`}>
                <div className={"view-more-content"} style={{maxHeight: !this.state.showMore ? this.state.limit : ''}}>
                    <div id={this.state.idUnique} className={"content-to-read"}>
                        {this.props.children}
                    </div>
                    {this.state.height > this.state.limit && (
                        <div className={`text-gradient ${this.props.kind === "comment" ? "comment-gradient" : ''}`} />
                    )}
                </div>
                {this.state.height > this.state.limit &&
                <span className={"view-more-button"} onClick={() => this.setState({showMore: !this.state.showMore})}>
                        {this.state.showMore ? 'Voir moins' : 'Voir plus'}
                    </span>
                }
            </div>
        )
    }
}

export default ViewMore;